
<template>
    <div class="__emails-container">	
      <div class="__navigators">
            <nav class="breadcrumb3">
              <ol>
                  <li><a v-bind:href="h.routes.home" v-text="t.label_home"         data-ba-i="breadcrumb-home"></a></li>
                  <li><a v-bind:href="h.routes.init" v-text="t.title_emails_app"   data-ba-i="breadcrumb-custom-emails"></a></li>
                  <li><a v-bind:href="h.routes.list_emails" v-text="t.emails_list" data-ba-i="breadcrumb-emails-list"></a></li>
              </ol>
          </nav>
      </div>
      <div class="__wrapper">
          <div class="__domain-container">
              <div class="domain__header">
                  <span class="__title" v-text="t.emails_list"></span>
              </div>
              <div class="container__list">
                
                <ul class="__domain-list" v-if="domains != null && domains.length > 0">
                    <li v-for="d in domains" v-bind:class="d.selected && !d.processing ? '__domain-selected': '__domain'">
                      <div class="text__domain"  @click="selectDoamin(d)" :data-ba-i="d.selected ? `show-domain-email-list` : `hide-domain-email-list`">
                        <span style='margin-right:0.5em; display:inline-block;'>&nbsp;</span>{{ toUnicode(d.domain, false) }} 
                        <i v-if="d.selected == false" class="fa fa-angle-down"></i>
                        <img v-else-if="d.processing == true" class="__loader" src="/internacional/public/office4/img/dashboard/load.svg">
                        <i v-else-if="d.selected == true" class="fa fa-angle-left"></i>
                      </div>
                      <ul v-if="d.selected">

                        <li class="__email" v-for="e in d.emails">
                          <span class="__desciption"> {{toUnicode(e.email, true)+ ' - '+(e.humandiskused == 'None' ? 0 : e.humandiskused)+'/'+e.humandiskquota}}</span>
                          
                          <a 
                            class="btn button__email button__delete" 
                            @click="deleteEmail(d, e, h.routes.delete, t)" data-ba-i="delete-email">
                              <img src="/internacional/public/emails-app/ic_delete.svg"/>
                              <span v-text="t.general_label_delete"></span>
                          </a> 

                          <a 
                            class="btn button__email button__change_pass" 
                            @click="showChangePassword(e)"
                            data-ba-i="open-change-email-password-modal">
                              <img src="/internacional/public/emails-app/change_pass_button.svg"/>
                              <span v-text="t.label_alterar_senha"></span>
                          </a>
                       
                          <a v-if="showSettings"
                            class="btn button__email button__gear" 
                            :href="e.settings"
                            data-ba-i="access-email-settings">
                            <img src="/internacional/public/emails-app/ic_gear.svg"/>
                            <span v-text="t.configurations"></span>
                          </a>

                        </li>
                        <li class="__email" v-if="!d.processing">
                          <div class="btn btn__webmail" @click="openModalCreate()" data-ba-i="open-create-email-modal">
                            <img :src="`/internacional/public/emails-app/email-icon.svg`"/>
                            {{t.label_criar}}
                          </div>
                        </li>
                        <li class="__email" v-if="d.emails != null && d.emails.length > 0" style="padding-top:0;">
                          <div class="btn btn__webmail" @click="openWebmail(d.webmail)" data-ba-i="access-webemail">
                            <img :src="`/internacional/public/emails-app/email-icon.svg`"/>
                            {{t.label_acessar_webmail}}
                          </div>
                        </li>
                      </ul>
                    </li>
                </ul>
                <div v-else>
                    <h2 class="no_domain_info" v-text="t.label_no_domain"></h2>
                </div>
              </div>
          </div>
      </div>

      <!-- CHANGE PASSWORD MODAL -->
      <div id="modalChangePassword" class="modal inmodal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-ba-i="close-change-password-modal"><span aria-hidden="true">&times;</span></button>
                    <div>
                        <img class="top-img" src="/internacional/public/emails-app/ic_change_password_modal.svg"/>
                        <h4 class="modal-title modal__title" v-text="t.label_alterar_senha"></h4>
                    </div>
                </div>
                <div class="modal-body">
                  <h3 v-text="textEmail"></h3>
                  <div class="input__div">
                    <input v-bind:class="input_password" :placeholder="t.label_new_password" type="password" v-model="password"/>
                    <div class="box-help-text-inputs">
                      <div>
                        <div v-if="password_empty" class="info__span" v-text="t.required"></div>
                        <div v-if="!passwords_match && !password_empty" class="info__span" v-text="t.pass_do_not_match"></div>
                      </div>
                      <p v-if="password" :class="[password.length < 10 ? 'red-color' : 'green-color']" v-text="password.length"></p>
                    </div>
                  </div>
                  
                  <div class="input__div">
                    <input v-bind:class="input_password2" :placeholder="t.label_new_password_confirm" type="password" v-model="password2"/>
                    <div class="box-help-text-inputs">
                      <div>
                        <div v-if="password_empty2" class="info__span" v-text="t.required"></div>
                        <div v-if="!passwords_match && !password_empty2" class="info__span" v-text="t.pass_do_not_match"></div>
                      </div>
                      <p v-if="password2" :class="[password2.length < 10 ? 'red-color' : 'green-color']" v-text="password2.length"></p>
                    </div>
                  </div>
                  <div class="input__div">
                    <div class="progress">
                      <div v-bind:class="progress_passwordStrength" role="progressbar" :aria-valuenow="passwordStrength" aria-valuemin="0" aria-valuemax="100" :style="'width:'+passwordStrength+'%'" v-text="passwordStrength+'%'">
                      </div>
                    </div>
                    <div class="progress__label" v-text="t.office_email_password_strength"></div>
                    <div class="info__span" v-if="password_weak"  v-text="t.password_strength_100"></div>
                  </div>
                  <div class="modal_footer">
                    <button class="btn btn__save" v-text="t.button_salvar" @click="savePassword()"></button> 
                  </div>
                </div>
            </div>
        </div>
      </div>
    
       <!-- CREATE EMAIL COMPONENT -->
      <create-email v-show="showCreate" :domain="domain" :translations="t" :handlers="h" :show="showCreate" v-on:created="createdEmail()" v-on:hide="openModalCreate()" ></create-email>
    
    </div>

</template>

<script type="text/javascript">
    import qs from "qs";
    import punycode from "punycode";
    export default {
    name: "emails-list",
    props: ["app"],
    data() {
        return {
        	h: this.app.handlers,
          t: this.app.translations,
          showSettings: this.app.showSettings,
          domains: this.app.domains,
          domain:  null,
          email: null,
          password: "",
          password2: "",
          textEmail: "",
          passwordStrength: 0,
          showCreate: false,

          //classes
          input_password: "input__normal",
          input_password2: "input__normal",
          progress_passwordStrength: "progress-bar progress-low",

          //flags
          passwords_match: true,
          password_empty: false,
          password_empty2: false,
          password_weak: false,
          clearForm:false
        };
    },
     watch:{
      password2(newValue, oldValue){
        if(!this.clearForm){
          if(newValue){
            this.password_empty2 = false
              if(this.password === this.password2){
                this.passwords_match = true
                this.input_password  = "input__normal"
                this.input_password2 = "input__normal"
              } else {
                this.passwords_match = false
                this.input_password  = "input__wrong"
                this.input_password2 = "input__wrong"
              }
          }else{
            this.password_empty2 = true
            this.input_password2  = "input__wrong"
          }
        }
      },
      password(newValue, oldValue){
        if(!this.clearForm){
          this.passwordStrength = this.getPasswordStrength(newValue);

          if(newValue){
            this.password_empty = false;
            this.password_weak = true;
            if(this.passwordStrength <= 66)
            {
              this.password_weak = true;
              this.progress_passwordStrength = "progress-bar progress-low";
            }
            else if(this.passwordStrength <= 99)
            {
              this.password_weak = true;
              this.progress_passwordStrength = "progress-bar progress-medium";
            }
            else
            {
              this.password_weak = false;
              this.progress_passwordStrength = "progress-bar progress-high";
            }

            if(this.password === this.password2){
              this.passwords_match = true
              this.input_password  = "input__normal"
              this.input_password2 = "input__normal"
            } else {
              this.passwords_match = false
              this.input_password  = "input__wrong"
              this.input_password2 = "input__wrong"
            }
          } else {
            this.password_empty = true
            this.input_password = "input__wrong"
          }
        }

      },
    },
    methods: {
       openModalCreate: function(){
        if(this.domain != null){

          if(this.showCreate){
            this.showCreate = false
          }else{
            this.showCreate = true
          }

        }
      },
      createdEmail(){
        this.openModalCreate()
        this.listEmails(this.domain)
      },
      selectDoamin(d){
        if(this.domain == null || !this.domain.processing){
          if(d.selected){
            this.domain = null
            d.selected  = false
          }else{
            if(this.domain !== null){
              this.domain.selected = false
            }

            this.domain  = d
            this.domain.selected  = true
            this.listEmails(d)
          }
        }
      },
      listEmails(d){
        d.emails = null
        d.processing = true
        let vm = this
        axios
          .post(
              vm.h.routes.list,
              qs.stringify({domain: d.domain })
          )
          .then(function(response) {
              if(response.data.status){
                d.emails = response.data.data.list
              }
          })
          .catch(function(error) {
              
          })
          .finally(function(){
            d.processing = false
          });
      },
      openWebmail(url){
        window.open(url,'_blank');
      },
      deleteEmail(d, e, route, t){
        var confirmLoader = $.confirm({
            title:  t.general_label_delete,
            content:  t.confirm_delete_email,
            type:'red',
            buttons: {
              deleteUser: {
                    text: t.general_label_delete,
                    btnClass: 'btn-danger',
                    action: function () {
                      confirmLoader.showLoading(true);
                      axios
                          .post(
                              route,
                              qs.stringify({domain: d.domain, email: e.user})
                          )
                          .then(function(response) {
                              if(response.data.status){
                                $.alert({
                                    title: t.label_success,
                                    content: response.data.data,
                                    type: 'green',
                                });

                                for (let i = 0; i < d.emails.length; i++) {
                                  if(d.emails[i].id == e.id){
                                    d.emails.splice(i, 1)
                                    d.emails.filter(function(val){return val})
                                    break;
                                  }
                                }

                              
                              }else{
                                $.alert({
                                  title: t.label_error,
                                  content: response.data.data,
                                  type: 'red',
                                });
                              }
                              confirmLoader.close();
                          })
                          .catch(function(error) {
                            confirmLoader.close();
                          });
                      return false;

                    }
                },
                cancelAction: {
                  text: t.button_cancelar
                }
            }
      });
      },
      showChangePassword(e){
        this.email = e
        this.textEmail = this.toUnicode(this.t.email, false) + ': ' +  this.toUnicode(e.email, true)
        this.clear()

        $('#modalChangePassword').modal('show')
      },
      getPasswordStrength(password){
        let strength = 0
        const regex_minusculas = /[a-z]/
        const regex_maiusculas = /[A-Z]/
        const regex_numeros    = /\d/
        const regex_special    = /[^a-zA-Z\d]/

          //Se contém um caractere minúsculo: soma 20
          if(regex_minusculas.exec(password) !== null)
            strength += 20

          //Se contém um caractere maiúsculo: soma 20
          if(regex_maiusculas.exec(password) !== null)
            strength += 20

          //Se contém um número: soma 20
          if(regex_numeros.exec(password) !== null)
              strength += 20

          //Se contém um caractere especial: soma 20
          if(regex_special.exec(password) !== null)
              strength += 20

          //Se a senha possuir 10 ou mais caracteres: soma 20
          //Se a senha possuir de 6 a 9 caracteres: soma 10
          if(password.length >= 10)
              strength += 20
          else if(password.length >= 6)
              strength += 10
          
        return strength
      },
      clear(){
        let vm = this
        vm.clearForm = true        
        vm.password = ""
        vm.password2 = ""
        vm.passwords_match = true
        vm.password_empty = false
        vm.password2_empty = false
        vm.passwordStrength = 0
        vm.password_weak = false
        vm.input_password = "input__normal"
        vm.input_password2 = "input__normal"
        vm.progress_passwordStrength = "progress-bar progress-low"

        setTimeout(function() {
          vm.clearForm = false                
        }, 1000)
      },
      isValidForm(){
        if(!this.password){
          this.input_password  = "input__wrong"
          this.password_empty = true
        }

        if(!this.password2){
          this.input_password2  = "input__wrong"
          this.password_empty2 = true
        }

        if(this.passwordStrength < 70){
          this.password_weak = true
        }

        if(this.passwords_match && !this.empty_password && !this.empty_password2 && this.passwordStrength == 100)
          return true
        else
          return false
      },
      savePassword(){
        if(this.isValidForm()){
          this.changePassword()
        }
      },
      changePassword(){
        let load = $.dialog({
          title: false,
          content: '',
          type: 'blue',
          onOpen: function () {
            load.showLoading(true)
          },
        });
        
        let vm = this
        axios
            .post(
                vm.h.routes.change_password,
                qs.stringify({domain: vm.domain.domain, email: vm.email.user, password: vm.password})
            )
            .then(function(response) {
                if(response.data.status){
                  $.alert({
                    title: vm.t.label_success,
                    content: response.data.data,
                    type: 'green',
                  });
                  $('#modalChangePassword').modal('hide')
                }else{
                  $.alert({
                    title: vm.t.label_error,
                    content: response.data.data,
                    type: 'red',
                  });
                }
            })
            .catch(function(error) {

            })
            .finally(function(){
                load.close()
            });


      },
      toUnicode(text, isEmail){

        if(!isEmail){
          return punycode.toUnicode(text)
        }else{
          let parts = text.split('@')
          return punycode.toUnicode(parts[0]) + '@' + punycode.toUnicode(parts[1]) 
        }
      },
  }
};
</script>

<style scoped lang="scss">

  .__emails-container {
    background: #fff;
    padding-bottom: 1rem;
  }

  .__navigators{
    overflow: hidden;
    nav{
      margin-left: 2%;
      margin-top: 0.5rem;
    }
  }

  .__wrapper{

      display: flex;
      flex-direction: row;
      height: 100%;
      padding-bottom: 5rem;
      .__domain-container {
          width: 80%;
          padding: 1rem 5px 2rem 5px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2rem;
          border: 1px solid #E5E5E5;
          background: var(--theme-color-primary);
          flex-direction: column;
          max-width: 1000px;
          
          .domain__header{
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 100%;
            height: 5rem;
            color: #fff;

            img{
              vertical-align: top;
              margin-right: 0.8rem;
              width: 2.8rem;
            }

            span{
              font-weight: bold;
              font-size: 1.9rem;
            }

            .__title{
              margin-top: 10px;
            }

        }
        .container__list{
            width: 100%;
            justify-content: center;
            display: contents;
          }
          .__domain-list{
              width: 90%;
              padding: 0 1rem;
              color: #fff;
              list-style-type: none;
              overflow-y: auto;
              height: 100%;
              overflow-x: hidden;

              &::-webkit-scrollbar-thumb {
                  background: #e9edf2;
              }
              &::-webkit-scrollbar-track {
                  background: var(--theme-color-primary);
              }

              @media screen and (min-width: 900px){
                height: 60vh;
              }
        
              .text__domain{
                padding-bottom: 15px;
                padding-top: 15px;
                font-size: 1.15rem;
                position: relative;
              }

              .__domain{
                  font-size: 20px;
                  min-height: 40px;
                  border-bottom: 1px solid #fff6;

                  &:hover{
                    background: var(--theme-color-primary-light);
                    cursor: pointer;
                  }

                  .__loader{
                    float:right;
                    margin-right: 10px;
                    width: 18.5px;
                  }
                  
                  i{
                    float:right;
                    margin-right: 10px;
                  }
              }

              .__domain-selected {
                  font-size: 20px;
                  min-height: 40px;
                  border-bottom: 0;
                  background: var(--theme-color-primary-light);
                  margin: 1rem -15px 0px -15px;

                  &:hover{
                    cursor: pointer;
                  }

                  .text__domain {
                    background: rgba(255, 255, 255, 0.2);
                  }

                  i{
                    width: 50px;
                    background: var(--theme-color-primary-light);
                    text-align: center;
                    height: 50px;
                    right: 0;
                    position: absolute;
                    top: -1px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    @media screen and (max-width: 769px){
                      height: 47px;
                    }
                  }

                .__email{
                  display: flex;
                  padding: 1rem 1.5rem;
                  font-size: 1.1rem;
                  min-height: 50px;
                  background: var(--theme-color-primary-light);

                  .__desciption {
                    grid-column: 1/4;
                    padding-right: 1rem;
                    flex: 1;
                  }

                .porgress___div{
                  padding-top: 25px;
                }

                  .__title {
                    grid-column: 1/4;
                  }

                  &:not(:nth-last-child(-n+2)) {
                    border-bottom: 1px solid #fff6;
                  }

                  .button__email{
                    min-width: 140px;
                    width: auto;
                    float: right;
                    display: flex;
                    align-items: center;
                    height: 34px;
                    justify-content: space-between;
                    margin: 0 5px;
                    span {
                      width: 100%;
                      font-weight: bold;
                      font-size: 0.75rem;
                    }
                    img{
                      width: 25px;
                    }
                  }

                .button__change_pass{
                  background-color: #69FF80;
                  color: #000;
                  padding: unset;

                  img {
                    background: #95FFA5;
                    height: 100%;
                    width: 50px;
                    padding: 3px 9px;
                  }

                  &:focus, &:focus-within{
                    color: #000 !important;
                  }
                }

                .button__delete{
                  background-color: #FE6262;
                  color: #fff;

                  &:focus, &:focus-within{
                    color: #fff !important;
                  }
                }

                .button__gear{
                  background-color: #FF9900;
                  color: #000000;
                  padding: unset;
                  img {
                    background: #FFB74B;
                    height: 100%;
                    width: 50px;
                    padding: 3px 9px;
                  }
                  &:focus, &:focus-within{
                    color: #fff !important;
                  }
                }

                .btn__webmail{
                  width: 95%;
                  background-color: rgba(255, 255, 255, 0.4);
                  margin: 0 auto;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #fff;
                  padding: 8px;
                  grid-column: 1/4;

                  img{
                    width: 25px;
                    margin-right: 10px;
                    margin-left: 10px;
                  }

                  &:focus, &:focus-within{
                    color: #fff !important;
                  }
                }
              }
            }
          }
      }
  }


  .modal__title{
    margin-top: 5px;
    font-size: 25px;
    text-align: center;
    color: #5B5B5B;
  }

  .modal-body{
      padding: 0px 30px 10px 30px;

      .modal_footer{
        display: flex;
        justify-content: center;
       
        .btn__save{
          background-color: #69FF80;
          min-width: 150px;
          min-height: 40px;
          text-transform: uppercase;
        }
      }
  }

  .modal-header{
      padding: 15px 10px 5px 10px;

      // .btn__close{
      //     padding: 0 10px;
      //     font-size: larger;
      //     display: contents;
      // }
  }
 
  .modal{
      top: 10%;
      @media only screen and (max-width: 600px) {
          top: 0;
      }

      h3{
        margin-top: 5%;
      }

      .input__div{
        margin-top: 5%;
        margin-bottom: 5%;
        .box-help-text-inputs{
          display: flex;
          justify-content: space-between;
        }
        
        .progress__label{
            display: flex;
            justify-content: center;
            padding-top: 8px;
            font-size: 12px;
            font-weight: bold;
        }

        input{
          padding: 0.5rem 0;
          font-size: 1rem;
          &:focus{
            border: 0;
            border-bottom: 1.5px solid #C4C4C4;
          }
        }

        .input__normal{
          border: 0;
          border-bottom: 1px solid #C4C4C4;
          width: 100%;
        }
        
        .input__wrong{
          border: 0;
          border-bottom: 1.5px solid #ff4d4d;
          width: 100%;
        }


        ::placeholder {
          color: #5B5B5B;
          padding-left: 25px;
        }
      }

    textarea:focus, input:focus{
        outline: none;
    }

    .info__span{
      padding-top: 8px;
      font-style: italic;
      font-size: .9rem;
    }

  .progress{
    height: 20px;
    margin-bottom:0;
    }
  }

  .no_domain_info{
    padding-top: 100px;
    padding-bottom: calc(100vh - 500px);
    color: #fff;
  }

  .progress-low{
    background-color: #66B3FF;
  }

  .progress-medium{
    background-color: #FF9900;
  }

  .progress-high{
    background-color: #00FF28;
  }

  .red-color{
    color: #ff4d4d;
  }

  .green-color{
    color: #00FF28;
  }

@media screen and (max-width: 992px) {
    .__wrapper {
        flex-direction: column;
        .__domain-container {
          width: 95%;
          margin-bottom: 10%;
          padding: 10px;
          max-height: 60%;
          border-radius: 1rem;

          .__domain-list {
              width: 100%;
              overflow-y: auto;
              max-height: 90%;
              .__email {
                display: grid !important;
                grid-template-columns: 1fr 1fr 1fr;
                row-gap: 0.7rem;
                .button__email {
                  min-width: unset !important;
                }
              }
          }
        }
    }

    .modal-dialog{
      top: 25%;
    }
}

@media screen and (max-width: 576px) { 
  .button__email {
    display: block !important;
    height: 26px !important;
    span {
      display: none;
    }
    img {
      margin: auto;
      background: transparent !important;
      zoom: .7;
    }
  } 
  .button__delete img {
    margin-top: -15px;
  }
}

</style>


// WEBPACK FOOTER //
// resources/office/js/components/emails-app/emails-list.vue